// "use server";
import axios, { AxiosError, AxiosInstance } from "axios";
// import https from "https";
const axiosInstance = (): AxiosInstance => {
  try {
    // const agent = new https.Agent({
    //   rejectUnauthorized: false,
    // });
    const axiosInstance = axios.create({
      baseURL: `${process.env.NEXT_PUBLIC_BASE_URL}/api`,
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
      // httpsAgent: agent,
    });
 
    // Add request interceptor
    axiosInstance.interceptors.request.use(
      (config) => {
        // console.log("Request:", {
        //   url: config.url,
        //   method: config.method,
        //   headers: config.headers,
        //   data: config.data,
        // });
 
        // Middleware logic: Sanitize 'x-forwarded-host'
        const forwardedHost = config.headers["x-forwarded-host"];
        if (forwardedHost) {
          const sanitizedHost = forwardedHost.split(",")[0].trim(); // Keep only the first host
          config.headers["x-forwarded-host"] = sanitizedHost; // Set the sanitized value
        }
 
        return config;
      },
      (error: AxiosError) => {
        return Promise.reject(error);
      }
    );
 
    // Add response interceptor
    axiosInstance.interceptors.response.use(
      async (response) => {
        // console.log("Response:", {
        //   status: response.status,
        //   data: response.data,
        // });
        return response;
      },
      async (error: AxiosError) => {
        console.log('errrorrrr', error)
        // if (error.response) {
        //   // console.error("Response Error:", {
        //   //   status: error.response.status,
        //   //   data: error.response.data,
        //   // });
 
        //   // Handle specific status codes
        //   if (error.response.status === 401) {
        //     console.error("Unauthorized access. Redirecting to login...");
        //     return Promise.reject(new Error("Unauthorized access."));
        //   }
        // } else {
        //   console.error("Network or unknown error:", error.message);
        // }
        return Promise.reject(error);
      }
    );
 
    return axiosInstance;
  } catch (error) {
    console.error("Axios Instance Creation Error:", error);
    throw new Error("Failed to create Axios instance");
  }
};
 
export default axiosInstance;